import React from 'react'
import { useAppSelector } from '../../../../hooks/redux'

import Alert from './Alert'

import { selectChatBox } from '../../../../slices/chatBoxSlice'

import useStyles from './styles'

const Alerts = () => {
  const { values, alertsHidden } = useAppSelector(selectChatBox)

  const alerts = React.useMemo(() => values.alerts ?? [], [values.alerts])

  const classes = useStyles()

  if (alerts.length === 0 || alertsHidden) {
    return null
  }

  return (
    <div className={classes.root}>
      {alerts.map(
        alert => !alert.hidden && <Alert key={alert.id} alert={alert} />
      )}
    </div>
  )
}

export default Alerts
